// src/routes/countriesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Countries from '../pages/countries/Countries';
import CreateCountries from '../pages/countries/CreateCountries';
import EditCountries from '../pages/countries/EditCountries';
import ProtectedRoute from '../components/global/ProtectedRoute';

const countriesRoutes = (
    <>
        {/* Countries List */}
        <Route
            path="/countries"
            element={
                <ProtectedRoute requiredPermission="countries_list">
                    <Countries />
                </ProtectedRoute>
            }
        />

        {/* Countries Archive */}
        <Route
            path="/countries/archive"
            element={
                <ProtectedRoute requiredPermission="countries_archive_list">
                    <Countries />
                </ProtectedRoute>
            }
        />

        {/* Create Country */}
        <Route
            path="/countries/create"
            element={
                <ProtectedRoute requiredPermission="countries_create">
                    <CreateCountries />
                </ProtectedRoute>
            }
        />

        {/* Edit Country */}
        <Route
            path="/countries/:id/edit"
            element={
                <ProtectedRoute requiredPermission="countries_edit">
                    <EditCountries />
                </ProtectedRoute>
            }
        />
    </>
);

export default countriesRoutes;